import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useFakeParticipantsStore } from '@/store/fakeParticipantsStore';

const MAX_PARTICIPANTS = 2500;
const WARN_THRESHOLD = 200;

export const FakeParticipantsPanel = () => {
  const [inputValue, setInputValue] = useState('50');
  const [collapsed, setCollapsed] = useState(false);

  const { count, generatedIds, apply, clear } = useFakeParticipantsStore();
  const isActive = generatedIds.length > 0;

  const handleApply = () => {
    const parsed = Math.min(
      Math.max(1, Math.round(Number(inputValue) || 0)),
      MAX_PARTICIPANTS,
    );
    setInputValue(String(parsed));
    apply(parsed);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleApply();
    }
  };

  const parsedValue = Math.round(Number(inputValue) || 0);
  const showWarning = parsedValue > WARN_THRESHOLD && !isActive;

  return (
    <div className="fixed right-16 bottom-56 z-50 w-260 rounded-md border border-silver-darken-50 bg-white shadow-lg">
      <button
        className="flex w-full items-center justify-between px-12 py-8 text-left"
        type="button"
        onClick={() => setCollapsed(!collapsed)}
      >
        <span className="text-small-brand-medium font-semibold text-silver-darken-80">
          Fake Participants
        </span>
        <span className="text-xs text-silver-darken-50">
          {collapsed ? '+' : '-'}
        </span>
      </button>

      {!collapsed && (
        <div className="flex flex-col gap-8 border-t border-silver-darken-20 px-12 py-8">
          <div className="flex items-center gap-8">
            <input
              className="w-full rounded-sm border border-silver-darken-50 px-8 py-4 text-small-brand-medium text-dark-black"
              max={MAX_PARTICIPANTS}
              min={1}
              placeholder="Count (1-500)"
              type="number"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
          </div>

          {showWarning && (
            <p className="text-xs text-yellow-darken-15">
              Counts above {WARN_THRESHOLD} may slow down the UI.
            </p>
          )}

          <div className="flex gap-8">
            <Button
              radius="sm"
              size="sm"
              variant="primary"
              onClick={handleApply}
            >
              Apply
            </Button>
            {isActive && (
              <Button radius="sm" size="sm" variant="secondary" onClick={clear}>
                Clear
              </Button>
            )}
          </div>

          {isActive && (
            <p className="text-xs text-silver-darken-80">
              {count} fake participants active
            </p>
          )}
        </div>
      )}
    </div>
  );
};
